import { EditableTextCell } from '@equip.health/ui';

interface InquiryNextStepsCellProps {
  inquiryId: string;
  nextSteps?: string;
  version: string;
  onSave?: (inquiryId: string, nextSteps: string, version: string) => void;
}

const InquiryNextStepsCell = ({
  inquiryId,
  nextSteps,
  version,
  onSave,
}: InquiryNextStepsCellProps) => {
  const handleChangeNextSteps = (value: string) => {
    if (value !== nextSteps) {
      onSave?.(inquiryId, value, version);
    }
  };

  return (
    <EditableTextCell
      editableText={nextSteps}
      id={inquiryId}
      onSave={handleChangeNextSteps}
      placeholder="Add next step"
    />
  );
};

export default InquiryNextStepsCell;
